import Vue from 'vue'
/*
 * 单选下拉树
 * data 数据
 * value 值
 * placeholder 提示
 * disabled 要不要显示 @change="changeSelect"
 */
Vue.component('cn-select-search', {
    template: `
	<el-select v-model="valueId" :placeholder="placeholderTxt" :disabled="disabled"  >	
		<div class="searchTxt"><el-input
		          placeholder="请输入关键字.." @input="keyUpSearch"
		          v-model="searchTxt">
		        </el-input></div>
		<el-option :key="0" label="全部客户" :value="0" v-show="v_whole"></el-option>
		<el-option v-for="item in companySouList" :key="item.id" :label="item.companyFullName" :value="item.id">
		</el-option>
	</el-select>	
	`,
    props: {

        placeholder: {
            type: String,
            default: function () {
                return '请选择..';
            }
        },
        value: {
            type: String,
            default: function () {
                return "";
            }
        },
        v_disabled: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        v_whole: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        data: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            disabled: this.v_disabled,
            valueId: this.value,
            searchTxt: "",
            placeholderTxt: this.placeholder,
            companySouList: []
        }
    },
    methods: {
        keyUpSearch: function () {
            console.log('keyUpSearch');
            if (this.searchTxt) {
                this.companySouList = this.data.filter(item => item.companyFullName.includes(this.searchTxt));
            } else {
                this.companySouList = [];
            }
        },
        reset: function () {

            if (this.valueId) {
                this.companySouList = this.data.filter(item => item.id == this.valueId);
            } else {
                this.companySouList = [];
            }
        }
    },
    beforeUpdate() {

        console.log('beforeUpdate');

        // if (this.searchTxt) {
        // 	this.companySouList = this.data.filter(item => item.companyFullName.includes(this.searchTxt));
        // } else {
        // 	this.companySouList = [];
        // }

        // if(this.searchTxt=="")
        // {
        // 	if (this.valueId) {
        // 		this.companySouList = this.data.filter(item => item.id.includes(this.valueId));
        // 	} else {
        // 		this.companySouList = [];
        // 	}
        // }

    },
    created() {
        if (this.value != "") {
            this.companySouList = this.data.filter(item => item.id.includes(this.value));
        }
        let _this = this;

        if (_this.data != null) {
            if (_this.data.length == 1) {

                _this.disabled = true;
                _this.companySouList = _this.data;
                _this.valueId = _this.data[0].id;
                this.$emit("val", _this.valueId);
            }
        }

    },
    watch: {

        valueId: function (newVal) {
            let _this = this;
            this.$emit("val", newVal);
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/select.component.js